import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Logo from '../assets/img/waras-logo-dark.png';
import Nav from './Nav';
import NavMobile from './NavMobile';
import { COMPANY } from '../data/content';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-40 h-[4.5rem] lg:h-20 transition-shadow duration-200 ${
        scrolled
          ? 'bg-surface-muted/90 backdrop-blur-md border-b border-line'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <div className='container mx-auto h-full flex items-center justify-between px-4 lg:px-8'>
        <Link to='/' className='flex-shrink-0' aria-label='Waras Delivery'>
          <img
            src={Logo}
            alt='Waras Delivery'
            className='h-12 lg:h-[3.75rem] w-auto object-contain'
          />
        </Link>

        <div className='hidden lg:flex items-center gap-6'>
          <Nav />
          <a href={COMPANY.playStore} target='_blank' rel='noopener noreferrer' className='btn btn-md'>
            Descargar app
          </a>
        </div>

        <div className='lg:hidden'>
          <NavMobile />
        </div>
      </div>
    </header>
  );
};

export default Header;
